import _get from 'lodash.get';

export const isValidImage = src => {
    return new Promise((resolve) => {
        let img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = src;
    });
};

export const scrollTo = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
};

export const DoRender = function(props) {
    if (!props.if) {
        return '';
    }

    return props.children;
};

export const getOnlineTotalPrice = (rooms = []) => {
    return rooms.reduce((prev, room) => {
        const onlinePay = getFirstOlinePayOptionWhenParamTrue([room], 'pay');
        const sum = onlinePay && onlinePay.amount ? Number(onlinePay.amount) : 0;        
        const result = prev + sum;
        return Number(result.toFixed(2));
    }, 0);
};

export const getCorrectOnlinePay = (rooms = []) => {
    // hack para obtener el onlinePay de un array de options en un array de rooms
    const failCase = { pay: false };

    if (!rooms || !rooms.length) {
        return failCase;
    }

    const withPay = getFirstOlinePayOptionWhenParamTrue(rooms, 'pay');
    const withPayLater =  getFirstOlinePayOptionWhenParamTrue(rooms, 'payLater');

    return withPay || withPayLater || failCase;
};

function getFirstOlinePayOptionWhenParamTrue(rooms = [], param = 'pay') {

    let result = null;
    
    rooms.forEach((room) => {

        const options = _get(room, 'options', []);
        
        // get first option with "PARAM" = TRUE
        const option = options.find((opt) => {
            return _get(opt, 'onlinePay', {})[param] === true;
        });

        if (option && !result) {
            result = { ...option.onlinePay };
        }
    });

    return result;
}

//Cuenta items repetidos en un array {count: x, value: x}
export function compressArray(original) {

    var compressed = [];
    var copy = original.slice(0);

    for (var i = 0; i < original.length; i++) {

        var myCount = 0;
        for (var w = 0; w < copy.length; w++) {
            if (original[i] == copy[w]) {
                myCount++;
                delete copy[w];
            }
        }

        if (myCount > 0) {
            var a = new Object();
            a.value = original[i];
            a.count = myCount;
            compressed.push(a);
        }
    }

    return compressed;
}


// WEBPACK FOOTER //
// ./src/components/Utils/shared.js